import { Button } from '@hue/design-system';
import { Moon, Sun } from 'lucide-react';
import type { SessionUser } from '../lib/api.js';
import { useAppearance } from './appearance.js';
export function PortalModeToggle({ user }: { user?: SessionUser | undefined }) {
  const { mode, choose } = useAppearance(user);
  return (
    <Button
      variant="outline"
      aria-label={`Usar modo ${mode === 'light' ? 'escuro' : 'claro'}`}
      onClick={() => choose({ mode: mode === 'light' ? 'dark' : 'light' })}
    >
      {mode === 'light' ? <Moon className="size-4" /> : <Sun className="size-4" />}
      <span className="sr-only sm:not-sr-only">{mode === 'light' ? 'Escuro' : 'Claro'}</span>
    </Button>
  );
}
